module.exports = __webpack_public_path__ + "media/site/images/logos/logo-rubylogic-alt-4696fffdc83c8de6fc302bd0e238ba48.svg";